import React from "react";

import { Grid, Input, Textarea, TextInput } from "~/ui";
import type { DocumentShippableEntity } from "~/utils/address-formatters";

export const DocumentShippableEntityPreviewEditor = ({
  value,
  onChange,
  error,
  label,
  withAsterisk,
}: {
  value: DocumentShippableEntity | null;
  onChange: (value: DocumentShippableEntity) => void;
  error?: React.ReactNode;
  label?: string;
  withAsterisk?: boolean;
}) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  const base = (v: DocumentShippableEntity | null): DocumentShippableEntity => ({
    name: v?.name ?? "",
    addressLines: v?.addressLines ?? [],
    phone: v?.phone ?? "",
    contact: v?.contact ?? "",
    logoUrl: v?.logoUrl,
  });

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...base(null),
      ...(value ?? {}),
      name: event.target.value,
    });
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...base(null),
      ...(value ?? {}),
      phone: event.target.value,
    });
  };

  const handleContactChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...base(null),
      ...(value ?? {}),
      contact: event.target.value,
    });
  };

  const handleAddressChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = event.target;
    const selectionStart = textarea.selectionStart;
    const selectionEnd = textarea.selectionEnd;

    const addressLines = textarea.value.split("\n");
    onChange({
      ...base(null),
      ...(value ?? {}),
      addressLines,
    });

    // Restore cursor position after state update
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.selectionStart = selectionStart;
        textareaRef.current.selectionEnd = selectionEnd;
      }
    }, 0);
  };

  return (
    <Input.Wrapper label={label} withAsterisk={withAsterisk} error={error}>
      <Grid>
        <Grid.Col span={12} sm={6}>
          <TextInput value={value?.name || ""} onChange={handleNameChange} label="Name" autoComplete="off" />
          <TextInput value={value?.contact || ""} onChange={handleContactChange} label="Contact Name" autoComplete="off" />
          <TextInput value={value?.phone || ""} onChange={handlePhoneChange} label="Phone" autoComplete="off" />
        </Grid.Col>
        <Grid.Col span={12} sm={6}>
          <Textarea
            ref={textareaRef}
            value={value?.addressLines?.join("\n") || ""}
            onChange={handleAddressChange}
            label="Address Fields"
            autoComplete="off"
            autosize
            rows={4}
            minRows={4}
          />
        </Grid.Col>
      </Grid>
    </Input.Wrapper>
  );
};
